import { useAppSelector } from "../app/hooks";
import {
  getCurrentBranchPermissions,
  getIsSuperAdmin,
} from "../features/loggingUser/loggingUserSlice";

export const useCanAccess = () => {
  const isSuperAdmin = useAppSelector(getIsSuperAdmin);
  const branchPermissions = useAppSelector(getCurrentBranchPermissions);

  return (permission: string): boolean => {
    if (isSuperAdmin) return true;
    return branchPermissions.includes(permission);
  };
};
